module.exports = __webpack_public_path__ + "img/hzjg_logo.f791bb4.png";